import { get, post, put, del } from '@/Libs/Request/index'
// const DOMAIN_NAME = 'http://172.21.24.31:3000';
const DOMAIN_NAME = '';
const NAME_SPACE = 'DC/';

export const vLoading = (state) => ({
  type: NAME_SPACE + 'V_LOADING',
  payload: {
    state
  }
});

export const receiveDestinationCollection = (DestinationCollection) => ({
  type: NAME_SPACE + 'RECEIVE_DESTINATION_COLLECTION',
  payload: {
    DestinationCollection
  }
});

export const fetchDestinationCollectionIfNeeded = () => {
  return (dispatch, getState) => {
    return get(`${DOMAIN_NAME}/api/area/tree`)
      .then(res => res.json())
      .then(json => {
        if (json.errno !== 0) {
          return;
        }
        dispatch(receiveDestinationCollection({
          data: json.data,
          loading: false,
        }));
      });
  }
}
